import { SectionHeader } from '../rows/SectionHeader'
import { MetricRow } from '../rows/MetricRow'
import { ConversionRow } from '../rows/ConversionRow'
import type { MonthMetrics } from '@/features/history/types'

interface FunnelSectionProps {
  metrics: MonthMetrics
  weeklyAvg: (v: number) => number
  formatNumber: (v: number) => string
  formatConversion: (from: number, to: number) => string
}

export function FunnelSection({ metrics, weeklyAvg, formatNumber, formatConversion }: FunnelSectionProps) {
  const { leads_count: leads, appointments_count: appts, new_visitors_count: visitors } = metrics
  return (
    <>
      <SectionHeader label="Лиды и воронка пробного" color="purple" />
      <MetricRow
        label="Лиды"
        metric={leads}
        weeklyPlan={weeklyAvg(leads.plan)}
        weeklyFact={weeklyAvg(leads.fact)}
        formatPlan={formatNumber}
        formatFact={formatNumber}
      />
      <MetricRow
        label="Записи на пробное"
        metric={appts}
        weeklyPlan={weeklyAvg(appts.plan)}
        weeklyFact={weeklyAvg(appts.fact)}
        formatPlan={formatNumber}
        formatFact={formatNumber}
      />
      <ConversionRow
        label="Конверсия Лиды → Записи"
        planConversion={formatConversion(leads.plan, appts.plan)}
        factConversion={formatConversion(leads.fact, appts.fact)}
      />
      <MetricRow
        label="Пришли на пробное"
        metric={visitors}
        weeklyPlan={weeklyAvg(visitors.plan)}
        weeklyFact={weeklyAvg(visitors.fact)}
        formatPlan={formatNumber}
        formatFact={formatNumber}
      />
      <ConversionRow
        label="Конверсия Записи → Приходы"
        planConversion={formatConversion(appts.plan, visitors.plan)}
        factConversion={formatConversion(appts.fact, visitors.fact)}
      />
    </>
  )
}
